import { useState } from 'react';
import { useNavigate, useParams } from '@tanstack/react-router';
import { Button, Paragraph, Spinner, Text, TextArea, XStack, YStack } from 'tamagui';
import { useParseShoppingListText } from '@mrrmlab/feature-shopping-list';

export function ListTextImportRoute() {
  const { listId } = useParams({ from: '/lists/$listId/text-import' });
  const navigate = useNavigate();
  const [text, setText] = useState('');
  const { mutate, isPending, error } = useParseShoppingListText();

  function handleParse() {
    if (!text.trim()) return;
    mutate(
      { text },
      {
        onSuccess: (result) => {
          void navigate({
            to: '/lists/$listId/review',
            params: { listId },
            search: { items: JSON.stringify(result.items) },
          });
        },
      },
    );
  }

  return (
    <YStack padding="$4" gap="$4" maxWidth={600}>
      <Text fontSize="$6" fontWeight="700">Text importieren</Text>
      <Paragraph color="$color10" fontSize="$3">
        Text aus Notiz, Foto-OCR oder einer anderen Quelle einfügen. Jede Zeile wird als eigener Artikel erkannt.
      </Paragraph>

      <TextArea
        value={text}
        onChangeText={setText}
        placeholder="Text hier einfügen…"
        rows={12}
        style={{ minHeight: 240 } as never}
        autoFocus
      />

      {error ? (
        <Paragraph color="$red10" fontSize="$3">{error.message}</Paragraph>
      ) : null}

      <XStack gap="$2">
        <Button
          size="$4"
          disabled={isPending || !text.trim()}
          onPress={handleParse}
        >
          {isPending ? <Spinner size="small" /> : 'Analysieren & Überprüfen'}
        </Button>
        <Button
          size="$4"
          chromeless
          disabled={isPending}
          onPress={() => void navigate({ to: '/lists/$listId', params: { listId } })}
        >
          Abbrechen
        </Button>
      </XStack>
    </YStack>
  );
}
